import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import usePageLoaded from '../../hooks/usePageLoaded'

import PaginationTagsAndSearch from './materials/paginationTagsAndSearch'
import Title from '../../components/ui/title/title'

import { RootState } from '../../store/rootReducer'
import { TagsListType } from '../../store/tags/tagsTyping'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import { getLangFromPath } from '../../i18next'
import { useLocation } from 'react-router-dom'

import { fetchTagsList } from '../../store/tags/tagsSlice'

const PaginationTags = () => {
    usePageLoaded()

    const [t] = useTranslation()
    const location = useLocation()

    const tags = useSelector<RootState, TagsListType[]>((state) => state.tags.tags.list)
    const totalTags = useSelector<RootState, string>((state) => state.tags.tags.total_count)

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.paginationTags[getLangFromPath(location.pathname)].title}</title>
                <meta
                    name="description"
                    content={META.paginationTags[getLangFromPath(location.pathname)].description}
                />
            </Helmet>
            <Title text={t('Tag list')} />
            <PaginationTagsAndSearch list={tags} total={+totalTags} />
        </div>
    )
}

// @ts-ignore
PaginationTags.getInitialProps = async ({ store, location, req }) => {
    const page = req ? req.query.p : new URLSearchParams(location.search).get('p')

    await store.dispatch(fetchTagsList({ order: '', p: page, limit: 300 }))
}

export default PaginationTags
